import React from "react";
import { Box, Card } from "rebass";

import { ArrowBottom } from "../styled/ArrowBottom";

interface IProps {
  isOpen: boolean;
}

export const Popover: React.FC<IProps> = ({ children, isOpen }) => (
  <Box
    css="position: absolute; top: -25px; right: 0; transform: translate(0, -100%); z-index: 3;"
    hidden={!isOpen}
  >
    <Card
      width="290px"
      px="21px"
      py="15px"
      borderRadius="12px"
      bg="#fff"
      boxShadow="0 -1px 84px -20px rgba(0, 0, 0, 0.34)"
    >
      {children}
    </Card>

    <ArrowBottom
      size={10}
      css="right: 30px;"
    />
  </Box>
);
